$(document).ready(function () {
    if (document.getElementById('back-link') != null) {
        var element = document.getElementById('back-link');
        element.setAttribute('href', document.referrer);
        element.onclick = function () {
            history.back();
        }
    }
});